import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { VisitService } from '../visits/visit.service';
import { ConsultationRoomService } from './consultation-room.service';
import { parseErrors } from '../shared/api.service';

const Video = require('twilio-video');

@Component({
  selector: 'consultation-room',
  templateUrl: 'consultation-room.component.html',
  styleUrls: ['./consultation-room.component.scss'],
  providers: [VisitService]
})

export class ConsultationRoomComponent implements OnInit, OnDestroy {
  room;
  visitReq;
  visit;
  loading = false;
  connected = false;
  audioEnabled = true;
  videoEnabled = true;
  stats;
  token;
  errors = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private visitService: VisitService,
    private consultationRoomService: ConsultationRoomService
  ) { }

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.loading = true;
      this.getVisit(params['visitId']);
    });
  }

  ngOnDestroy() {
    this.disconnect();
  }

  markAsReadyAndConnect() {
    if (this.visitReq) { this.visitReq.unsubscribe(); }
    let visit = Object.assign(this.visit, { providerReady: true });
    this.visitReq = this.visitService.save(visit).subscribe(_visit => {
      this.visit = _visit;
      this.connect();
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  connect() {
    this.loading = true;
    if (!this.visit.providerTwilioToken) { return; }
    Video.connect(this.visit.providerTwilioToken, {
      audio: true,
      video: { width: 600 }
    }).then(room => {
      this.room = room;
      this.getStats(this.room);
      this.connected = true;

      console.log('Connected to Room "%s"', room.name);

      const localParticipant = room.localParticipant;
      console.log('Connected to the Room as LocalParticipant "%s"', localParticipant.identity);
      this.participantConnected(localParticipant);

      room.participants.forEach(this.participantConnected);
      room.on('participantConnected', this.participantConnected);

      room.on('participantDisconnected', this.participantDisconnected);
      room.once('disconnected', error => room.participants.forEach(this.participantDisconnected));
    });
  }

  // JDavis: this is code from Ionic.  need similar for the angular version
  //           to confirm disconnect.
  // confirmDisconnect(){
  //   const confirm = this.alertCtrl.create({
  //     title: "Leave Video Room",
  //     subTitle: "Are you sure?",
  //     buttons: [
  //       {
  //         text: 'Yes, I am done',
  //         handler: ()=> {
  //           this.disconnect();
  //         }
  //       },
  //       {
  //         text: 'No, continue the visit',
  //         role: 'cancel',
  //         handler: ()=> {
  //           console.log('cancelled');
  //         }
  //       }
  //     ]
  //   });
  //
  //   confirm.present();
  // }

  disconnect() {
    if (this.room) { this.room.disconnect(); }
    this.room = null;
    this.connected = false;

    let className = 'local-participant';
    let containers = document.getElementsByClassName(className);
    for (let i = 0; i < containers.length; i++) {
      containers[i].innerHTML = '';
    }
  }

  toggleAudio() {
    this.audioEnabled = !this.audioEnabled;
    this.room.localParticipant.tracks.forEach(track => {
      if (track.kind === 'audio') {
        this.audioEnabled ? track.enable() : track.disable();
      }
    });
  }

  toggleVideo() {
    this.videoEnabled = !this.videoEnabled;
    this.room.localParticipant.tracks.forEach(track => {
      if (track.kind === 'video') {
        this.videoEnabled ? track.enable() : track.disable();
      }
    });
  }

  getVisit(visitId) {
    if (this.visitReq) { this.visitReq.unsubscribe(); }
    this.visitReq = this.visitService.getVisit(visitId).subscribe(visit => {
      this.visit = visit;
      // this.connect();
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  participantConnected(participant) {
    console.log('Participant connected', participant);
    let className = 'remote-participant';
    let div = document.createElement('div');
    div.id = participant.sid;

    if (participant && (
      participant.constructor.name === 'LocalParticipant' || participant.identity === 'provider1'
    )) {
      className = 'local-participant';
    }

    participant.on('trackAdded', track => { div.appendChild(track.attach()); });
    participant.tracks.forEach(track => { div.appendChild(track.attach()); });
    participant.on('trackRemoved', track => { track.detach().forEach(element => element.remove()); });

    let container;
    let containers = document.getElementsByClassName(className);
    if (containers && containers.length) {
      container = containers[0];
    } else {
      console.log('No Container Found!');
    }

    if (container) {
      div.style.width = '100%';
      div.style.height = '100%';

      let videoElements = div.getElementsByTagName('video');
      if (videoElements && videoElements.length) {
        videoElements[0].style.width = '100%';
        videoElements[0].style.height = '100%';
      }

      container.appendChild(div);
    }
  }

  participantDisconnected(participant) {
    console.log('Participant "%s" disconnected', participant.identity);

    participant.tracks.forEach(track => {
      track.detach().forEach(element => element.remove());
    });
    document.getElementById(participant.sid).remove();
  }

  async getStats(room) {
    if (room) {
      const stats = await room.getStats();
      console.log(stats);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/consultation-room/consultation-room.component.ts